import React from "react";

export const Section = ({ id, eyebrow, title, subtitle, children, className = "", wrapper = "" }) => {
  return (
    <section id={id} className={`py-16 lg:py-24 ${wrapper}`}>
      <div className={`mx-auto max-w-7xl px-5 lg:px-10 ${className}`}>
        {(eyebrow || title || subtitle) && (
          <div className="mb-12 max-w-3xl">
            {eyebrow && (
              <p className="mb-3 text-sm font-semibold uppercase tracking-[0.18em] text-brand-sand-dark">
                {eyebrow}
              </p>
            )}
            {title && (
              <h2 className="font-heading text-3xl font-bold leading-tight tracking-tight text-brand-slate-dark sm:text-4xl lg:text-5xl">
                {title}
              </h2>
            )}
            {subtitle && (
              <p className="mt-5 text-lg leading-relaxed text-muted-foreground">
                {subtitle}
              </p>
            )}
          </div>
        )}
        {children}
      </div>
    </section>
  );
};

export const PageHero = ({ eyebrow, title, subtitle, image, children }) => {
  return (
    <section className="relative overflow-hidden bg-brand-slate-dark">
      <div className="absolute inset-0">
        <img
          src={image}
          alt=""
          className="h-full w-full object-cover opacity-50"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-brand-slate-dark via-brand-slate-dark/80 to-brand-slate-dark/30" />
      </div>
      <div className="relative mx-auto max-w-7xl px-5 py-20 sm:py-28 lg:px-10 lg:py-32">
        <div className="max-w-3xl text-brand-cream">
          {eyebrow && (
            <p className="mb-4 inline-block rounded-full bg-brand-sand/20 px-4 py-1.5 text-xs font-semibold uppercase tracking-wider text-brand-sand">
              {eyebrow}
            </p>
          )}
          <h1 className="font-heading text-4xl font-bold leading-tight tracking-tight sm:text-5xl lg:text-6xl">
            {title}
          </h1>
          {subtitle && (
            <p className="mt-6 max-w-2xl text-lg leading-relaxed text-brand-cream/85">
              {subtitle}
            </p>
          )}
          {children && <div className="mt-8">{children}</div>}
        </div>
      </div>
    </section>
  );
};

export const Card = ({ children, className = "" }) => (
  <div
    className={`rounded-3xl border border-black/5 bg-brand-cream p-8 shadow-[0_1px_2px_rgba(0,0,0,0.04)] transition-all duration-300 hover:-translate-y-1 hover:shadow-lg ${className}`}
  >
    {children}
  </div>
);
